import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SystemsettingsRoutingModule } from './systemsettings-routing.module';
import { MenulistComponent } from './menu/menulist/menulist.component';
import { AddmenuComponent } from './menu/addmenu/addmenu.component';
import { AddmenuitemsComponent } from './menuitems/addmenuitems/addmenuitems.component';
import { ListmenuitemsComponent } from './menuitems/listmenuitems/listmenuitems.component';
import { MenuService } from './menu/menu.service';
import { MenuitemsService } from './menuitems/menuitems.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LayoutModule } from '@angular/cdk/layout';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PermissionsComponent } from './permissions/permissions.component';
import { PermissionService } from './permissions/permission.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AppcolorComponent } from './appcolor/appcolor.component';
import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { QrcommissioncategoriesComponent } from './qrcommissioncategories/qrcommissioncategories.component';
import { QrcommissioncategoriesService } from './qrcommissioncategories/qrcommissioncategories.service';
import { CategoryPermissionComponent } from './category-permission/category-permission.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { GoodcardintcInterceptor } from '../goodcardintc.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { QrfeescategoryComponent } from './qrfeescategory/qrfeescategory.component';
import { QrfeescategoryService } from './qrfeescategory/qrfeescategory.service';
import { AssistanceDirectchargePermComponent } from './assistance-directcharge-perm/assistance-directcharge-perm.component';


@NgModule({
  declarations: [
    MenulistComponent,
    AddmenuComponent,
    AddmenuitemsComponent,
    ListmenuitemsComponent,
    MatspinnerComponent,
    PermissionsComponent,
    AppcolorComponent,
    QrcommissioncategoriesComponent,
    CategoryPermissionComponent,
    QrfeescategoryComponent,
    AssistanceDirectchargePermComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SystemsettingsRoutingModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    LayoutModule,
    MatIconModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatPaginatorModule,
    MatGridListModule,
    MatTableModule,
    MatCheckboxModule,
    NgxWebstorageModule.forRoot(),
    TranslateModule,
    FlexLayoutModule,
    NgxMatColorPickerModule,
    MatSlideToggleModule,
    MatAutocompleteModule

  ],
  providers: [MenuService, MenuitemsService, PermissionService, QrcommissioncategoriesService,
    QrfeescategoryService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GoodcardintcInterceptor,
      multi: true
    },

    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS }]
})
export class SystemsettingsModule { }
